/* Patina Studio: native integration: progressive enhancement only; no external dependencies. */
(() => {
  'use strict';
  if (window.__patinaCoreLoaded) return;
  window.__patinaCoreLoaded = true;

  class PatinaHeader extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const syncHeight = () => {
        const height = Math.round(this.getBoundingClientRect().height);
        document.body.style.setProperty('--header-height', `${height}px`);
        document.body.style.setProperty('--header-group-height', `${height}px`);
      };
      this.observer?.disconnect();
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(syncHeight);
        this.observer.observe(this);
      }
      syncHeight();
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const open = event.target.closest('details[open]') || this.querySelector('details[open]');
        if (!open) return;
        open.open = false;
        open.querySelector(':scope > summary')?.focus();
        event.stopPropagation();
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeMenus();
      }, options);
      this.addEventListener('toggle', (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open || !details.matches('[data-ps-disclosure]')) return;
        const list = details.closest('.ps-nav__list');
        list?.querySelectorAll('[data-ps-disclosure][open]').forEach((other) => {
          if (other !== details && !other.contains(details)) other.open = false;
        });
      }, { ...options, capture: true });
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!this.contains(document.activeElement)) this.closeMenus();
        });
      }, options);
    }
    closeMenus() { this.querySelectorAll('details[open]').forEach((item) => { item.open = false; }); }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  }
  if (!customElements.get('ps-header')) customElements.define('ps-header', PatinaHeader);

  function initialize(root = document) {
    const reference = new URLSearchParams(window.location.search).get('reference');
    if (reference) {
      root.querySelectorAll('[data-ps-reference]').forEach((input) => {
        // Assign as a value, never as HTML. Keep merchant/customer entered text intact.
        if (!input.value) input.value = reference.replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 500);
        const preferences = input.closest('details');
        if (preferences) preferences.open = true;
      });
    }
    root.querySelectorAll('[data-ps-finder]').forEach((form) => {
      if (form.dataset.psReady) return;
      form.dataset.psReady = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const url = new URL(form.action, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.search = '';
        for (const [key, value] of new FormData(form)) {
          if (typeof value === 'string' && value.trim()) url.searchParams.append(key, value.trim());
        }
        url.hash = 'ResultsList';
        window.location.assign(url.toString());
      });
    });
    root.querySelectorAll('.ps-guide-page').forEach((guide) => {
      const body = guide.querySelector('.ps-guide-body');
      const list = guide.querySelector('.ps-guide-aside nav ul');
      if (!body || !list || guide.dataset.psTocReady) return;
      guide.dataset.psTocReady = 'true';
      const headings = [...body.querySelectorAll('h2')];
      if (!headings.length) return;
      const items = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `ps-guide-${guide.closest('[id]')?.id || 'content'}-${index + 1}`;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', `#${heading.id}`);
        a.textContent = heading.textContent;
        li.append(a);
        items.append(li);
      });
      list.replaceChildren(items);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
